import { get, post, del, put } from './requests'

export const login = payload => post(['users', 'login'], { removeTrailingSlash: true }, payload)

export const signup = payload => post(['users', 'register'], { removeTrailingSlash: true }, payload)

export const forgot = payload =>
  post(['users', 'forgotPass'], { removeTrailingSlash: true }, payload)

export const reset = payload => post(['users', 'resetPass'], { removeTrailingSlash: true }, payload)

export const getProfileInfo = key =>
  get(['users', 'profileInfo'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const subscribe = key => payload =>
  post(
    ['api', 'subscribe'],
    { removeTrailingSlash: true, headers: { Authorization: `Bearer ${key}` } },
    payload
  )

export const unsubscribe = key =>
  post(['api', 'subscribe', 'cancel'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const deleteAccount = key =>
  del(['users', 'deleteAccount'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const updateProfile = key => payload =>
  put(
    ['users', 'updateProfile'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const updatePassword = key => payload =>
  put(
    ['users', 'updatePassword'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const toggleUpdate = key =>
  put(['users', 'toggleUpdate'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const updateLastActivityAt = key => payload =>
  post(
    ['users', 'updateLastActivityAt'],
    { removeTrailingSlash: true, headers: { Authorization: `Bearer ${key}` } },
    payload
  )

export const confirmEmail = key => payload =>
  post(
    ['users', 'confirmEmail'],
    { removeTrailingSlash: true, headers: { Authorization: `Bearer ${key}` } },
    payload
  )

export const resendConfirmEmail = key =>
  post(['users', 'resendConfirmEmail'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })



// WEBPACK FOOTER //
// ./src/services/users.js